<template>
  <el-dialog :title="$t('signRule.editTitle')" :visible.sync="dialogVisible" width="40%" @close="handleClose">
    <el-form ref="form" :model="editSignRuleInfo" label-width="120px" :rules="rules" class="text-left">
      <el-form-item :label="$t('signRule.table.ruleName')" prop="ruleName">
        <el-input v-model="editSignRuleInfo.ruleName" :placeholder="$t('signRule.placeholder.ruleName')" />
      </el-form-item>
      <el-form-item :label="$t('signRule.table.cycleDays')" prop="cycleDays">
        <el-input-number v-model="editSignRuleInfo.cycleDays" :min="1" :max="365"
          :placeholder="$t('signRule.placeholder.cycleDays')" />
      </el-form-item>
      <el-form-item :label="$t('signRule.table.rewardAmount')" prop="rewardAmount">
        <el-input-number v-model="editSignRuleInfo.rewardAmount" :min="0"
          :placeholder="$t('signRule.placeholder.rewardAmount')" />
      </el-form-item>
      <el-form-item :label="$t('signRule.table.extraRewardAmount')" prop="extraRewardAmount">
        <el-input-number v-model="editSignRuleInfo.extraRewardAmount" :min="0"
          :placeholder="$t('signRule.placeholder.extraRewardAmount')" />
      </el-form-item>
      <el-form-item :label="$t('signRule.table.remark')" prop="remark">
        <el-input v-model="editSignRuleInfo.remark" type="textarea" :rows="3"
          :placeholder="$t('signRule.placeholder.remark')" maxlength="512" show-word-limit />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="editSignRule">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateSignRule } from '@/api/admin/sign/signRuleApi'

export default {
  name: 'EditSignRule',
  data() {
    return {
      dialogVisible: false,
      editSignRuleInfo: {
        ruleId: '',
        ruleName: '',
        cycleDays: 7,
        rewardAmount: 0,
        extraRewardAmount: 0,
        remark: ''
      },
      rules: {
        ruleName: [
          { required: true, message: this.$t('signRule.ruleNameRequired'), trigger: 'blur' }
        ],
        cycleDays: [
          { required: true, message: this.$t('signRule.cycleDaysRequired'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(row) {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.editSignRuleInfo = { ...row }
        // 确保数字类型
        this.editSignRuleInfo.cycleDays = parseInt(this.editSignRuleInfo.cycleDays) || 7
        this.editSignRuleInfo.rewardAmount = parseInt(this.editSignRuleInfo.rewardAmount) || 0
        this.editSignRuleInfo.extraRewardAmount = parseInt(this.editSignRuleInfo.extraRewardAmount) || 0
        this.editSignRuleInfo.remark = this.editSignRuleInfo.remark || ''
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },
    handleClose() {
      this.$refs.form && this.$refs.form.resetFields()
    },
    async editSignRule() {
      try {
        await this.$refs.form.validate()
        await updateSignRule(this.editSignRuleInfo)
        this.$message.success(this.$t('common.saveSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        this.$message.error(error.message || this.$t('common.saveFailed'))
        console.error('保存失败:', error)
      }
    }
  }
}
</script>
